<bootstrap-popup [id]="id" [title]="'Exporter en PDF'" [displaySubject]="displaySubject" [modalSize]="'modal-lg'">
	<!-- Modal generation du pdp -->
	<form role="form" class="form-horizontal">
		<div class="form-group row">
			<div class="form-group row">
				<div class="col-md-3"></div>
				<div class="col-md-3">
					<label class="checkbox-inline">
						<input type="radio" name="choixLang" id="choixLangEn" [(ngModel)]="lang" value="EN" />
						FR / EN
					</label>
				</div>
				<div class="col-md-3">
					<label class="checkbox-inline">
						<input type="radio" name="choixLang" id="choixLangFr" [(ngModel)]="lang" value="ES" />
						FR / ES
					</label>
				</div>
				<div class="col-md-3"></div>
			</div>
			<div class="form-group row">
				<div class="col-md-1"></div>
				<div class="col-md-11">
					<label class="checkbox-inline">
						<input type="checkbox" name="choixAddTravaux" id="choixAddTravaux" [(ngModel)]="addBlankLinesTravaux" />
						Exporter des lignes supplémentaires pour les travaux et entreprises extérieures et sous-traitantes ?
					</label>
				</div>
				<div class="col-md-1"></div>
				<div class="col-md-11">
					<label class="checkbox-inline">
						<input type="checkbox" name="choixAddAnalyse" id="choixAddAnalyse" [(ngModel)]="addBlankLinesAnalyseGlobale" />
						Exporter des lignes supplémentaires dans la partie "Analyse globale des risques" et "Analyse globale des impacts environnementaux" ?
					</label>
				</div>
				<div class="col-md-1"></div>
				<div class="col-md-11">
					<label class="checkbox-inline">
						<input type="checkbox" name="choixAddValidation" id="choixAddValidation" [(ngModel)]="addBlankLinesValidation" />
						Exporter des lignes supplémentaires dans la partie "Validation {{ valideurSignatairesApplicable ? 'et émargement ' : '' }}du plan de prévention" ?
					</label>
				</div>
				<div class="col-md-1"></div>
				<div class="col-md-11">
					<label class="checkbox-inline">
						<input type="checkbox" name="choixAddEmargement" id="choixAddEmargement" [(ngModel)]="addBlankLinesEmargement" />
						Exporter des lignes supplémentaires dans la partie "{{ valideurSignatairesApplicable ? 'Liste des intervenants' : 'Tableau d\'émargement du plan de prévention par les intervenants' }}" ?
					</label>
				</div>
				<div class="col-md-2"></div>
				<div class="col-md-10" *ngIf="addBlankLinesEmargement">
					<label class="radio-inline">
						<input type="radio" name="choix10lignes" id="choix10lignes" [value]="10" [(ngModel)]="nbLinesEmargement" />
						10
					</label>
					<label class="radio-inline">
						<input type="radio" name="choix20lignes" id="choix15lignes" [value]="20" [(ngModel)]="nbLinesEmargement" />
						20
					</label>
					<label class="radio-inline">
						<input type="radio" name="choix30lignes" id="choix20lignes" [value]="30" [(ngModel)]="nbLinesEmargement" />
						30
					</label>
				</div>
			</div>
		</div>
		
		<div class="form-group row section-upload">
		    <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($any($event))" (onFileLeave)="fileLeave($any($event))">
		        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
		          Glisser / Déposer vos fichiers au format PDF ici
		          <button class="file-selector" type="button" (click)="openFileSelector()">
		          	<i class="fa-regular fa-file-pdf fa-2x text-danger"></i>
		          </button>
		        </ng-template>
		    </ngx-file-drop>
		    <div class="upload-table" *ngIf="annexes.length">
		        <table class="table">
		            <thead>
		                <tr><th>Annexes choisis</th></tr>
		            </thead>
		            <tbody class="upload-name-style">
		                <tr *ngFor="let item of annexes; let i=index">
		                    <td width="40%"><strong>{{ item.relativePath }}</strong></td>
		                    <td width="10%">
		                    	<i class="fa fa-trash fa-2x text-danger" (click)="removeFile(item)"></i>
	                    	</td>
	                    	<td width="50%"></td>
		                </tr>
		            </tbody>
		        </table>
		    </div>
		</div>
		
	</form>
	
	<div class="row">
		<div class="col-md-12">
			<div class="form-group text-center">
				<button type="button" class="btn btn-primary" style="margin-right: 10px" (click)="onCloseRequested()">
					Fermer
				</button>
				<button type="button" class="btn btn-success" data-dismiss="modal" (click)="generatePdf()" [disabled]="!lang" >
					Générer le PDF
				</button>
			</div>
		</div>
	</div>

</bootstrap-popup>
